export default "__VITE_ASSET__hbyCk$km__"